// extracted by mini-css-extract-plugin
module.exports = {"contracted":"styles_contracted__aZBwI","faded":"styles_faded__oJIsh","content":"styles_content__nI67a","button":"styles_button__xR3kD"};